module.exports = __webpack_public_path__ + "static/img/h3-1.e2aa224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h3-1.png
// module id = YZmM
// module chunks = 1